import { useCallback, useSyncExternalStore } from "react";

const key = "budgeter.location";
const listeners = new Set<() => void>();

function read(): boolean {
  try {
    return localStorage.getItem(key) !== "off";
  } catch {
    return true;
  }
}

/** Whether Quick Add may use the device's location (on unless turned off). */
export function useLocationSetting(): [boolean, (on: boolean) => void] {
  const value = useSyncExternalStore((l) => {
    listeners.add(l);
    return () => listeners.delete(l);
  }, read);
  const set = useCallback((on: boolean) => {
    try {
      localStorage.setItem(key, on ? "on" : "off");
    } catch {
      // Without storage the setting just doesn't persist.
    }
    for (const l of listeners) {
      l();
    }
  }, []);
  return [value, set];
}
